/* Obtain backend URL to make requests */
export const env = process.env.REACT_APP_BACKEND_DOMAIN_URL;
export const envTest = process.env.REACT_APP_BACKEND_DOMAIN_URL_TEST;
export const envStaging = process.env.REACT_APP_BACKEND_DOMAIN_URL_STAGING;
export const envProd = process.env.REACT_APP_BACKEND_DOMAIN_URL_PROD;
export const envVersion =
  process.env.REACT_APP_BACKEND_DOMAIN_URL_VERSION ||
  "https://care-api-staging.appspot.com";
export const envVersionTest =
  process.env.REACT_APP_BACKEND_DOMAIN_URL_VERSION_TEST ||
  "https://care-api-test.appspot.com";
export const envVersionStaging =
  process.env.REACT_APP_BACKEND_DOMAIN_URL_VERSION_STAGING ||
  "https://care-api-staging.appspot.com";
export const envVersionProd =
  process.env.REACT_APP_BACKEND_DOMAIN_URL_VERSION_PROD ||
  "https://care-api-prod.appspot.com";
export const geolocationEnv =
  "https://us-central1-care-api-prod.cloudfunctions.net/geolocation";
